<template>
<div id="forgot-content" class="modal-content">
  <div class="auth-logo-box">
    <a href="index.html" class="logo logo-admin">
      <img src="assets/landing/images/favicon_1.ico" alt="iTender" height="55" class="auth-logo"/>
    </a>
  </div>
    <div class="text-center">
        <h4 class="modal-title">{{ $t('recovery.title') }}</h4>
    </div>
    <span 
      v-if="errorMsgFromApi" 
      class="my-1 d-block w-100 text-center text-danger" 
    >
        {{errorMsgFromApi}}
    </span>
    <span 
      v-if="msgFromApi" 
      class="my-1 d-block w-100 text-center text-primary" 
    >
        {{msgFromApi}}
    </span>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label for="useremail">Մուտքանուն</label>
                <input v-model="fields.username" type="text" id="username" class="form-control-forgot">
            </div>
            <button @click="sendResetLink" class="btn btn-primary btn-round btn-block waves-effect waves-light" type="button">
                {{ $t('recovery.recovery_btn') }}<i class="fa fa-sign-in" aria-hidden="true"></i></button>
        </form>
    </div>
</div>
</template>

<script>
export default {
  name: 'ResetPasswordModal',
  data(){
     return {
      showSignupModal: false,
      showResetPasswordModal: false,
      fields: {
        username: '',
      },
      rememberMe: true,
      errorMsgFromApi: '',
      msgFromApi: '',
      isLoginPending: false,
      isErrorShake: false,
    }
  },
  methods: {
    sendResetLink(){
      this.$client.post('forgot/password/link', this.fields).then(({data}) => {
        if(!data.error && data.message === 'mail was sent'){
          this.msgFromApi = 'Գաղտնաբառի վերականգնման հղումը ուղարկվել է ձեր էլ. Հասցեին'
          this.errorMsgFromApi = null;
        } else {
          this.errorMsgFromApi = 'Տվյալ մուտքանունով օգտատեր չի գտնվել'
          this.msgFromApi = null;
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/main.scss';
</style>
